// Angular
import {
  Component,
  ViewChild,
  OnInit,
  ElementRef,
  HostListener,
} from "@angular/core";
// Models
// External
import {
  AngularFireDatabase,
  FirebaseListObservable,
} from "angularfire2/database";
import * as lodash from "lodash";
import { Attachment } from "./../../models/attachment";
import { FirebaseApp } from "angularfire2";
import * as moment from "moment";
import { Subject } from "rxjs/Subject";
import { DatePipe } from "@angular/common";
import { ApiService } from "../../services/api";

@Component({
  templateUrl: "./user-report.component.html",
  selector: "app-user-report",
})
export class UserReportComponent implements OnInit {
  public users: Array<any>;

  public filterargs: any;
  public imageLoader = true;

  public unappropiateReasons: any;
  constructor(
    private fireDatabase: AngularFireDatabase,
    private apiService: ApiService,
    private datePipe: DatePipe,
    private firebase: FirebaseApp
  ) {
    this.filterargs = {
      report: {},
    };

    var currentYear = new Date().getFullYear();
    var diff = currentYear - 2017;
  }
  ngOnInit() {
    this.unappropiateReasons = {
      inappropriate1: "Posting Inappropriate Content",
      inappropriate2: "Posting Spam",
      inappropriate3: "Posting annoying content",
      inappropriate4: "This profile is pretending to be someone else",
      inappropriate5:
        "Might be posting my intellectual property without authorization",

      spam1: "Spam",
    };
    this.initPostsList();
  }

  public dateChange(event) {
    this.filterargs.date = this.datePipe.transform(event, "yyyy-MM-dd");
  }

  initPostsList() {
    this.users = [];

    const fireObject = this.fireDatabase
      .object(`user-reports`)
      .subscribe((result) => {
        console.log(result);

        lodash.forEach(result, async (item, reportUserId) => {
          console.log(Object.keys(item), reportUserId);
          let report = item[Object.keys(item)[0]];
          const date = new Date(report.timestamp * 1000);
          const o =
            date.getFullYear() +
            "-" +
            ("0" + (date.getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + date.getDate()).slice(-2);
          let post = await this.getUser(reportUserId);
          post = Object.assign(post, {
            report_by: await this.getUser(Object.keys(item)[0]),
            report_reason: this.unappropiateReasons[report["report_type"]],
            date: o,
          });

          this.users.push(post);
          console.log(this.users);
        });
        if (fireObject) {
          fireObject.unsubscribe();
          this.imageLoader = false;
        }
      });
  }
  async getUser(uid) {
    let promise = new Promise<any>((resolve, reject) => {
      if (typeof uid == "string") {
        this.apiService.object("users/" + uid).then((result) => {
          result.key = uid;
          resolve(result);
        });
      }
    });
    return promise;
  }

  public blockUser(item) {
    //  console.log(item);

    if (confirm("Are you sure,you want to Block the user?")) {
      this.apiService
        .set(`/users/${item.key}/isBlock`, true)
        .then(() => {
          // this.goToPage(this.currentPage);
          item.isBlock = true;
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
  unblockUser(item) {
    if (confirm("Are you sure,you want to Unblock the user?")) {
      this.apiService
        .set(`/users/${item.key}/isBlock`, false)
        .then(() => {
          // this.goToPage(this.currentPage);
          item.isBlock = false;
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
  // --------------------------------------edit text of modal post text--------------------------------
}
